module.exports = __webpack_public_path__ + "img/17-erottamattomat.6dd90e9b.jpg";